(() => {
  console.log('[LM Recos] boot');

  // ---------- Utils ----------
  const LOG = '[LM Recos]';
  const qs  = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const ROOT = window.Shopify?.routes?.root || '/';

  function getSectionsList() {
    // Standard Dawn-seksjoner for drawer + ikon
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function getSectionsCsv() {
    return getSectionsList().join(',');
  }

  function getSectionsUrlValue() {
    return `${window.location.pathname}${window.location.search || ''}`;
  }

  function parseData() {
    try {
      const el = qs('#lm-recos-data');
      if (!el) return null;

      const raw = JSON.parse(el.textContent || '{}');

      const products = (raw.products || []).map((p) => ({
        ...p,
        per_pack: (!p.per_pack || p.per_pack <= 0) ? 1 : p.per_pack
      }));

      const main_product = raw.main_product
        ? {
            title: raw.main_product.title || '',
            image: raw.main_product.image || ''
          }
        : null;

      return {
        socket_count: Number(raw.socket_count || 0),
        main_product,
        products
      };
    } catch (e) {
      console.error(LOG, 'Parse error', e);
      return null;
    }
  }

  function bulbWord(n) {
    return Number(n) === 1 ? 'lyspære' : 'lyspærer';
  }

  function getRecommendedPacks(prod) {
    const perPack = Math.max(1, Number(prod?.per_pack || 1));

    // Hvis vi vet behovet, sett "riktig antall" automatisk
    if (state.socketCount > 0) {
      return Math.max(1, Math.ceil(state.needed / perPack));
    }

    // Hvis vi ikke vet behovet: default 1
    return 1;
  }

  function syncRowSelectionUI(row) {
    const pickBtn = qs('.lm-recos-pick', row);
    const step = qs('.lm-recos-step', row);
    const input = qs('.lm-qty-input', row);
    const qty = Number(input?.value || 0);

    if (qty > 0) {
      if (pickBtn) pickBtn.hidden = true;
      if (step) step.hidden = false;
    } else {
      if (pickBtn) pickBtn.hidden = false;
      if (step) step.hidden = true;
    }
  }
  function updateAddButtonLabel() {
    const btn = qs('#lm-recos-add');
    if (!btn) return;

    let totalSelectedPacks = 0;

    qsa('.lm-recos-row .lm-qty-input').forEach((inp) => {
      totalSelectedPacks += Number(inp.value || 0);
    });

    // Hvis minst én pære er valgt -> "Legg til valgte pærer"
    // Hvis ingen er valgt -> "Fortsett uten pærer"
    btn.textContent = totalSelectedPacks > 0
      ? 'Legg til valgte pærer'
      : 'Fortsett uten pærer';
  }

  // ---------- State ----------
  const state = {
    socketCount: 0,
    mainProduct: null,
    products: [],
    lampQtyInput: null,
    submittedLampQty: null,

    get lampQty() {
      // Bruk faktisk qty fra submit (mest robust)
      if (this.submittedLampQty && this.submittedLampQty > 0) return this.submittedLampQty;

      const v = this.lampQtyInput ? Number(this.lampQtyInput.value || 1) : 1;
      return v > 0 ? v : 1;
    },

    get needed() {
      return Math.max(0, this.socketCount * this.lampQty);
    }
  };

  // ---------- Modal UI ----------
  function renderMainProductSummary() {
    const box = qs('#lm-recos-main-product');
    if (!box) return;

    const p = state.mainProduct;
    if (!p || (!p.title && !p.image)) {
      box.hidden = true;
      box.innerHTML = '';
      return;
    }

    const qtyText = `Antall valgt: ${state.lampQty > 0 ? state.lampQty : 1}`;
    const imgHtml = p.image
      ? `<img src="${p.image}" alt="">`
      : `<div style="width:48px;height:48px;border-radius:8px;background:#f2f2f2;"></div>`;

    box.innerHTML = `
      ${imgHtml}
      <div class="lm-recos-main-meta">
        <div class="lm-recos-main-title">${p.title || ''}</div>
        <div class="lm-recos-main-sub">${qtyText}</div>
      </div>
    `;
    box.hidden = false;
  }

  function renderList() {
    const list = qs('#lm-recos-list');
    if (!list) return;
    list.innerHTML = '';

    state.products.forEach((p, idx) => {
      const row = document.createElement('div');
      row.className = 'lm-recos-row';
      row.dataset.index = String(idx);

      const imgHtml = p.image
        ? `<img src="${p.image}" alt="">`
        : '<div style="width:72px;height:72px;background:#f2f2f2;border-radius:8px;"></div>';

      row.innerHTML = `
        ${imgHtml}
        <div class="lm-recos-meta">
          <div class="lm-recos-title">${p.title}</div>
          <div class="lm-recos-price">${p.price_formatted || ''}${p.price_formatted ? ' ' : ''}(pakke: ${p.per_pack})</div>
          <div class="lm-recos-coverage">
            Dekker: <span class="lm-cover-val">0</span>${state.socketCount > 0 ? ` av <span class="lm-need-val">${state.needed}</span>` : ''}
          </div>
        </div>

        <div class="lm-recos-actions">
          <button type="button" class="lm-recos-pick">Velg denne</button>

          <div class="lm-recos-step" role="group" aria-label="Antall pakker" hidden>
            <button type="button" class="lm-minus" aria-label="Mindre">−</button>
            <input type="number" class="lm-qty-input" min="0" step="1" value="0" inputmode="numeric" aria-label="Antall pakker">
            <button type="button" class="lm-plus" aria-label="Mer">+</button>
          </div>
        </div>
      `;

      list.appendChild(row);
    });
  }

  function updateHeaderAndCoverage() {
    const titleEl = qs('#lm-recos-title');
    const headerTitleEl = qs('#lm-recos-header-title');

    // Fast topptekst (hvis element finnes)
    if (headerTitleEl && !headerTitleEl.textContent.trim()) {
      headerTitleEl.textContent = 'Husk lyskilde!';
    }

    if (titleEl) {
      if (state.socketCount > 0) {
        titleEl.hidden = false;
        titleEl.textContent = `Du trenger ${state.needed} ${bulbWord(state.needed)}`;
      } else {
        titleEl.hidden = true; // vis kun "Husk lyskilde!"
        titleEl.textContent = '';
      }
    }

    renderMainProductSummary();

    qsa('.lm-recos-row').forEach((row) => {
      const idx = Number(row.dataset.index || 0);
      const prod = state.products[idx];
      if (!prod) return;

      const inp = qs('.lm-qty-input', row);
      const packs = Number(inp?.value || 0);
      const cover = packs * (prod.per_pack || 1);

      const coverEl = qs('.lm-cover-val', row);
      const needEl = qs('.lm-need-val', row);

      if (coverEl) coverEl.textContent = String(cover);
      if (needEl) needEl.textContent = String(state.needed);

      syncRowSelectionUI(row);
    });
    updateAddButtonLabel();
  }

  function attachRowHandlers() {
    qsa('.lm-recos-row').forEach((row) => {
      const idx = Number(row.dataset.index || 0);
      const prod = state.products[idx];

      const pickBtn = qs('.lm-recos-pick', row);
      const minus = qs('.lm-minus', row);
      const plus  = qs('.lm-plus', row);
      const input = qs('.lm-qty-input', row);

      // "Velg denne" -> automatisk riktig antall
      pickBtn?.addEventListener('click', () => {
        const recommended = getRecommendedPacks(prod);
        input.value = String(recommended);
        syncRowSelectionUI(row);
        updateHeaderAndCoverage();
      });

      minus?.addEventListener('click', () => {
        const v = Math.max(0, Number(input.value || 0) - 1);
        input.value = String(v);
        syncRowSelectionUI(row);
        updateHeaderAndCoverage();
      });

      plus?.addEventListener('click', () => {
        const current = Number(input.value || 0);
        const v = Math.max(0, current + 1);
        input.value = String(v);
        syncRowSelectionUI(row);
        updateHeaderAndCoverage();
      });

      input?.addEventListener('input', () => {
        if (input.value === '') return;
        const n = Number(input.value);
        input.value = String(isNaN(n) || n < 0 ? 0 : Math.floor(n));
        syncRowSelectionUI(row);
        updateHeaderAndCoverage();
      });

      syncRowSelectionUI(row);
    });
  }

  function openModal() {
    const modal = qs('#lm-recos-modal');
    if (!modal) {
      console.warn(LOG, 'Fant ikke #lm-recos-modal i DOM.');
      return;
    }

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');

    renderMainProductSummary();
    renderList();
    attachRowHandlers();
    updateHeaderAndCoverage();
  }

  function closeModal() {
    const modal = qs('#lm-recos-modal');
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
  }

  window.__lmOpenBulbModal = openModal; // manuell test

  // ---------- Cart helpers ----------
  function markDrawerAsNonEmpty() {
    const drawer = qs('cart-drawer');
    if (!drawer) return;

    drawer.classList.remove('is-empty');
    drawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
  }

  function addOneFormData({ id, quantity, includeSections = false }) {
    const fd = new FormData();
    fd.append('id', String(id));
    fd.append('quantity', String(quantity));

    if (includeSections) {
      fd.append('sections', getSectionsCsv());
      fd.append('sections_url', getSectionsUrlValue());
    }

    return fetch(`${ROOT}cart/add.js`, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    });
  }

  async function addLampViaForm(form) {
    const fd = new FormData(form);

    // Ikke be om sections her – vi skal vise pære-modal uten å åpne drawer
    const res = await fetch(`${ROOT}cart/add.js`, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    });

    if (!res.ok) {
      let msg = `HTTP ${res.status}`;
      try { msg = (await res.text()) || msg; } catch (_) {}
      throw new Error(msg);
    }

    return await res.json();
  }

  async function fetchSectionsMap() {
    const params = new URLSearchParams();
    params.set('sections', getSectionsCsv());
    params.set('sections_url', getSectionsUrlValue());

    const url = `${ROOT}?${params.toString()}`;
    const res = await fetch(url, {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    });

    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  }

  async function fetchCartState() {
    const res = await fetch(`${ROOT}cart.js`, {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    });

    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  }

  function openDrawerWithSections(sectionsMap, cartState = null) {
    const drawer = qs('cart-drawer');

    if (drawer && typeof drawer.renderContents === 'function') {
      markDrawerAsNonEmpty();

      const payload = {
        id: Date.now(),
        ...(cartState || {}),
        sections: sectionsMap
      };

      drawer.renderContents(payload);
      setTimeout(markDrawerAsNonEmpty, 0);
      return;
    }

    const host = qs('cart-drawer');
    if (host) {
      markDrawerAsNonEmpty();
      setTimeout(() => host.classList.add('animate', 'active'), 0);
      document.body.classList.add('overflow-hidden');
    }
  }

  async function addSelectedBulbsThenOpenDrawer() {
    const picks = [];

    qsa('.lm-recos-row').forEach((row) => {
      const idx = Number(row.dataset.index || 0);
      const prod = state.products[idx];
      const qty = Number(qs('.lm-qty-input', row)?.value || 0);

      if (prod && qty > 0) {
        picks.push({ id: prod.variant_id, quantity: qty });
      }
    });

    let sectionsMap = null;

    if (picks.length) {
      // Alle unntatt siste → vanlig add. Siste → add med sections.
      for (let i = 0; i < picks.length; i++) {
        const it = picks[i];
        const isLast = i === picks.length - 1;

        const resp = await addOneFormData({
          id: it.id,
          quantity: it.quantity,
          includeSections: isLast
        });

        if (!resp.ok) {
          let msg = `HTTP ${resp.status}`;
          try { msg = (await resp.text()) || msg; } catch (_) {}
          console.error(LOG, 'Feil ved add:', msg);
          continue;
        }

        const data = await resp.json();
        if (isLast && data && data.sections) {
          sectionsMap = data.sections;
        }
      }
    } else {
      // Ingen pærer valgt → hent seksjoner via GET
      try {
        sectionsMap = await fetchSectionsMap();
      } catch (e) {
        console.warn(LOG, e);
      }
    }

    closeModal();

    let cartState = null;
    try {
      cartState = await fetchCartState();
    } catch (e) {
      console.warn(LOG, e);
    }

    if (!sectionsMap) {
      try {
        sectionsMap = await fetchSectionsMap();
      } catch (e) {
        console.warn(LOG, e);
      }
    }

    if (sectionsMap) openDrawerWithSections(sectionsMap, cartState);
  }

  // ---------- Product form override ----------
  function findProductForm() {
    const candidates = [
      'product-form form[action*="/cart/add"]',
      'form[action*="/cart/add"]'
    ];

    for (const sel of candidates) {
      const f = qs(sel);
      if (f) return f;
    }

    const addBtn = qs('button[name="add"], button[type="submit"][name="add"]');
    if (addBtn) return addBtn.closest('form');

    return null;
  }

  function installProductFormOverride() {
    const form = findProductForm();
    if (!form) {
      console.warn(LOG, 'Fant ikke product form');
      return;
    }

    if (form.dataset.lmRecosBound === '1') return;
    form.dataset.lmRecosBound = '1';

    state.lampQtyInput = form.querySelector('input[name="quantity"]') || state.lampQtyInput;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      try {
        const submitFd = new FormData(form);
        const submittedQty = Number(submitFd.get('quantity') || 1);
        state.submittedLampQty = submittedQty > 0 ? submittedQty : 1;

        await addLampViaForm(form);
        markDrawerAsNonEmpty();
      } catch (err) {
        console.error(LOG, 'Lamp add failed, fallback:', err);

        try {
          HTMLFormElement.prototype.submit.call(form);
        } catch (_) {
          form.submit();
        }
        return;
      }

      openModal();
      console.log(LOG, 'Lamp added, opening bulb modal (drawer paused).');
    }, { capture: true });
  }

  // ---------- Global handlers ----------
  function attachGlobalHandlers() {
    qsa('[data-lm-dismiss], [data-lm-close]').forEach((b) => {
      b.addEventListener('click', () => {
        closeModal();
      });
    });

    qs('#lm-recos-add')?.addEventListener('click', addSelectedBulbsThenOpenDrawer);

    // Live oppdater hvis qty på produktsiden endres (før submit)
    const qty = (state.lampQtyInput =
      state.lampQtyInput || qs('form[action*="/cart/add"] input[name="quantity"]'));

    if (qty) {
      ['change', 'input'].forEach((evt) => qty.addEventListener(evt, () => {
        updateHeaderAndCoverage();
      }));
    }

    document.addEventListener('shopify:section:load', () => {
      state.lampQtyInput = qs('form[action*="/cart/add"] input[name="quantity"]') || state.lampQtyInput;
      installProductFormOverride();
      updateHeaderAndCoverage();
    });
  }

  // ---------- INIT ----------
function init() {
  const d = parseData();

  if (!d) {
    console.warn(LOG, 'Mangler eller ugyldig #lm-recos-data. Pæremodal init stoppet.');
    return;
  }

  state.socketCount = d.socket_count;
  state.mainProduct = d.main_product || null;
  state.products = Array.isArray(d.products) ? d.products : [];

  // ✅ VIKTIG: Ikke aktiver modal hvis ingen tilhørende produkter finnes
  if (!state.products.length) {
    console.log(LOG, 'Ingen tilhørende produkter funnet. Bruker vanlig legg-i-handlekurv.');
    return;
  }

  console.log(LOG, 'Ready with', {
    antall_lyskilder: state.socketCount,
    recoCount: state.products.length,
    handles: state.products.map((p) => p.handle)
  });

  installProductFormOverride();
  attachGlobalHandlers();
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();